import { constants } from '@tradetrust-tt/token-registry-v5';

const contractAddress = constants.contractAddress;

export { contractAddress };
